import { render, staticRenderFns } from "./Tabelapreco.vue?vue&type=template&id=4525ef24"
import script from "./Tabelapreco.vue?vue&type=script&lang=js"
export * from "./Tabelapreco.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports